module.exports = __webpack_public_path__ + "img/arrow_left.dbaaae7d.svg";